<template>
  <div
    class="loading-wrap"
    :class="{ 'loading-full': full, 'color-white': onDarkBackground, 'loading-wrap--narrow': narrow }"
  >
    <div class="loading-spinner" :class="{ small }" />
    <p v-if="full" data-testid="loadingSpinnerFull">{{ $t('meta.loading') }}...</p>
    <div v-if="$slots.content" class="loading-spinner-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    full: { type: Boolean, required: false, default: false },
    onDarkBackground: {
      type: Boolean,
      default: false,
    },
    narrow: { type: Boolean, required: false, default: false },
    small: { type: Boolean, required: false, default: false },
  },
}
</script>

<style lang="scss" scoped>
.loading-wrap {
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 1.5rem;

  &--narrow {
    padding: 1rem 0;

    &:only-child {
      padding: 0;
    }
  }

  .loading-spinner {
    margin: 0;
  }
}

.loading-spinner-content {
  width: 100%;
}

.loading-full {
  min-height: calc(100vh - var(--header-height));
  align-items: center;
  gap: 0.5rem;

  p {
    text-align: center;
    font-size: 1rem;
    color: var(--binity-blue);
  }
}

.color-white.loading-full p {
  color: white;
}

.loading-spinner {
  display: block;
  height: 24px;
  width: 24px;
  margin: 14px auto 0 auto;
  position: relative;
  -webkit-animation: rotation 0.6s infinite linear;
  -moz-animation: rotation 0.6s infinite linear;
  -o-animation: rotation 0.6s infinite linear;
  animation: rotation 0.6s infinite linear;
  border-left: 3px solid #314053;
  border-right: 3px solid #f1f1f1;
  border-bottom: 3px solid #f1f1f1;
  border-top: 3px solid #f1f1f1;
  border-radius: 100%;

  &.small {
    height: 12px;
    width: 12px;
    border-left: 2px solid #314053;
    border-right: 2px solid #f1f1f1;
    border-bottom: 2px solid #f1f1f1;
    border-top: 2px solid #f1f1f1;
  }
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
@-moz-keyframes rotation {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotation {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
